import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";

export default EvalRunConfigExpectedEventTable;

function EvalRunConfigExpectedEventTable(props) {
  const { expectedEvents, onEditExpectedEvent, onDeleteExpectedEvent } = props;

  if (expectedEvents.length === 0) return null;

  return (
    <Table>
      <TableHead>
        <TableHeader>Persona</TableHeader>
        <TableHeader>Event</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {expectedEvents.map((expectedEvent, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{expectedEvent.persona}</TableCell>
              <TableCell>{expectedEvent.event}</TableCell>
              <TableCell>
                <div className="flex items-center gap-x-2">
                  <Button
                    plain
                    onClick={() => onEditExpectedEvent(expectedEvent, idx)}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    plain
                    onClick={() => onDeleteExpectedEvent(idx)}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
